import React from 'react';
//import { useSelector, useDispatch } from 'react-redux';


import Company from "api/Company";
import User from "api/User";

import ComanyModel from 'models/Company';
import PaginationModel from 'models/Pagination';
import Collection from 'models/Collection';

import {
  LOGIN_SUCCESS,
  LOGOUT,
	HIDE_MODAL,
	MESSAGE_INFO,
	MESSAGE_SUCCES,
	SET_USER
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";
import messageSlice from 'redux/messageSlice';
import { connect } from "react-redux";

import {Overview as CompanyOverview} from 'views/company/Overview';

class CompanyUserOverviewController extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false,items: [], pagination: new PaginationModel()};
		//navigate('/', { replace: true })
	}
	
	componentDidMount() {
		this.getData();
	}

	connectCompanyByCode = async(data) => {
		const {dispatch} = this.props;
		try {
			dispatch(showLoader());
			const response = await Company.connectCompanyByCode(data);
			dispatch({type: HIDE_MODAL});
			dispatch({ type: MESSAGE_SUCCES, "message": "Bedrijf gekoppeld door koppelcode", "header": "Bedrijf connection" });
			this.getData();
			dispatch(hideLoader());
		} catch(error) {
			console.log( " error ", error );
			dispatch(hideLoader());
		}				
		
	}


	setCurrentCompany = (data) => {
		const {dispatch} = this.props;
		dispatch(showLoader());
		User.changeActiveCompany(data)
			.then((response) => {
				dispatch({ type: SET_USER, payload: { user : response.data } });
				dispatch(messageSlice.actions.submitMessage({action: SET_USER, payload: { user : response.data }}));
				dispatch(hideLoader());
			})
			.catch((err) => {
				console.log("ERROR LOG.. ", err);
				dispatch(hideLoader());
			})
	}
		
	getData = (page = 0) => {
		const {dispatch} = this.props;
		const { pagination } = this.state;
		dispatch(showLoader(true));
		Company.get(page)
			.then((response) =>   {
				pagination.addData(response.data);
			this.setState({
				isLoaded: true,
				items: (new Collection()).addData(response.data, new ComanyModel() )
			});
			dispatch(hideLoader());
		})
		.catch(() => {
			dispatch(hideLoader());
		});
	}

	render() {
	const { items, pagination } = this.state;
	const { user } = this.props;
	return <CompanyOverview items={items} user={user} pagingEventHandler={this.getData} pagination={pagination} setCurrentCompanyEvent={this.setCurrentCompany} connectCompanyByCodeEvent={this.getData} />;
	}

}

function mapStateToProps(state) {
  const { isLoggedIn, user } = state.auth;
  return {
    isLoggedIn,
	user
  };
}

export default connect(mapStateToProps)(CompanyUserOverviewController);